import * as Sentry from '@sentry/gatsby';

Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development',
    sampleRate: 1.0,
});
